import {
    SkyNetSpreadSheetConfigType,
} from 'app/shared-components/SkyNetSpreadSheet'
import {
    AdditionalFeesTable,
} from 'app/Apps/Rates/RateCards/AdditionalFees/AdditionalFees.types'
import {
    AdditionalFeesConfigParams,
    getCommonAdditionalFeesFields,
    createSpreadsheetConfig,
} from 'app/Apps/Rates/components/AdditionalFeesSpreadsheet/AdditionalFeesSpreadsheet.config'

export default function getAPricingAdditionalFeesConfig(
    params: AdditionalFeesConfigParams,
): SkyNetSpreadSheetConfigType<keyof AdditionalFeesTable> {
    const fields = getCommonAdditionalFeesFields(params)

    return createSpreadsheetConfig(fields)
}
